import type { ApolloLink } from '@apollo/client/core'
import { onError } from '@apollo/client/link/error'
import { HttpLink } from '@apollo/client/link/http'
import { fromPromise } from '@apollo/client/link/utils'
import { setContext } from '@apollo/client/link/context'
import type { ActorRef } from 'xstate'

export function createAuthLink(token: string | null): ApolloLink {
  if (token === null) {
    throw new Error('Token not found')
  }
  return setContext(async () => ({
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  }))
}

export function createAuthErrorLink(params: {
  getTokenFunc: () => Promise<string>
  workerActorRef?: ActorRef<any, any, any> | null
}): ApolloLink {
  const { getTokenFunc, workerActorRef } = params
  return onError(({ graphQLErrors, networkError, operation, forward }) => {
    //Memo:  ここで例外がスローされた場合、どこにもキャッチされることはない

    if (graphQLErrors) {
      for (const err of graphQLErrors) {
        if (err.extensions !== undefined && err.extensions.code === 'invalid-jwt') {
          return fromPromise(
            getTokenFunc().catch((error) => {
              console.log(`Fetch Token error: ${error}`)
              workerActorRef?.send({ type: 'ERROR', error })
              return
            })
          )
            .filter((value) => Boolean(value))
            .flatMap((token) => {
              operation.setContext({
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${token}`
                }
              })
              return forward(operation)
            })
        }
      }
    }
    if (networkError) {
      const message = `Network error: ${networkError}`
      console.log(message)
      workerActorRef?.send({ type: 'NETWORK_PAUSE', error: networkError })
    }
  })
}

export function createHttpLink(endpoint: string): HttpLink {
  return new HttpLink({
    uri: endpoint
  })
}
